<script setup>
import { computed } from 'vue';
import { ATTENTION_HEALTH } from 'dashboard/helper/workflowHealth';
import { dynamicTime } from 'shared/helpers/timeHelper';

const props = defineProps({
  health: { type: String, default: 'ok' },
  lastExecutionAt: { type: Number, default: null },
});

const TONE = {
  ok: 'bg-n-teal-3 text-n-teal-11',
  failed: 'bg-n-ruby-3 text-n-ruby-11',
  unconfirmed: 'bg-n-amber-3 text-n-amber-11',
  delivery_attention: 'bg-n-amber-3 text-n-amber-11',
  idle: 'bg-n-alpha-2 text-n-slate-11',
  never_ran: 'bg-n-alpha-2 text-n-slate-11',
  draft: 'bg-n-alpha-2 text-n-slate-11',
  inactive: 'bg-n-alpha-2 text-n-slate-11',
};

const HINTS = {
  failed: 'FLOW_AUTOMATIONS.INDEX.HEALTH.FAILED_HINT',
  unconfirmed: 'FLOW_AUTOMATIONS.INDEX.HEALTH.UNCONFIRMED_HINT',
  delivery_attention: 'FLOW_AUTOMATIONS.INDEX.HEALTH.DELIVERY_HINT',
  idle: 'FLOW_AUTOMATIONS.INDEX.HEALTH.IDLE_HINT',
  never_ran: 'FLOW_AUTOMATIONS.INDEX.HEALTH.NEVER_RAN_HINT',
  draft: 'FLOW_AUTOMATIONS.INDEX.HEALTH.DRAFT_HINT',
};

const toneClass = computed(() => TONE[props.health] ?? TONE.ok);
const hintKey = computed(() => HINTS[props.health] ?? null);
const needsAttention = computed(() => ATTENTION_HEALTH.has(props.health));
const lastRunLabel = computed(() =>
  props.lastExecutionAt ? dynamicTime(props.lastExecutionAt) : null
);
</script>

<template>
  <span class="inline-flex items-center gap-1.5">
    <span
      class="inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium whitespace-nowrap"
      :class="toneClass"
      :title="hintKey ? $t(hintKey) : undefined"
    >
      <span
        v-if="needsAttention"
        aria-hidden="true"
        class="i-ph-warning mr-1 size-3.5 shrink-0"
      />
      {{ $t(`FLOW_AUTOMATIONS.INDEX.HEALTH.${health}`) }}
    </span>
    <span class="text-xs text-n-slate-11 whitespace-nowrap">
      {{
        lastRunLabel
          ? $t('FLOW_AUTOMATIONS.INDEX.HEALTH.LAST_RUN', { time: lastRunLabel })
          : $t('FLOW_AUTOMATIONS.INDEX.HEALTH.NEVER')
      }}
    </span>
  </span>
</template>
